var React = require('react');

function Doc (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M38.9 54.08V32.46c0-.91.37-1.28 1.3-1.28h22.38c.48 0 .85.14 1.2.49 2.28 2.27 4.58 4.54 6.88 6.79.34.34.51.7.51 1.19l-.01 36.16c0 .85-.4 1.24-1.25 1.24H40.14c-.87 0-1.24-.36-1.24-1.24V54.08zm22.95-20.82H40.98v41.75H69.1V40.4h-6.08c-.78 0-1.16-.39-1.16-1.16v-5.53l-.01-.45zm2.05 5.06h3.45l-3.45-3.45v3.45z","key":0}),React.createElement("path",{"d":"M64.09 52.83v1.99h-18.1v-1.99h18.1zM45.99 61.07v-2.01h18.07v2.01H45.99zM45.99 65.41h18.08v2.02H45.99v-2.02zM45.99 48.48v-2.01h11.83v2.01H45.99z","key":1}),React.createElement("circle",{"cx":"54.83","cy":"54.83","r":"37.43","fill":"none","stroke":"#000","strokeWidth":"2.04","strokeMiterlimit":"10","key":2})]);
}

Doc.defaultProps = {"viewBox":"0 0 110 110","width":"110","height":"110"};

module.exports = Doc;

Doc.default = Doc;
